import { useState } from 'react'
import './styles.css'
import Navbar from './../components/Navbar'
import  Footer from '../components/Footer'
import iconFb from './../images/icon-fb-c.svg'
import iconLinkedin from './../images/icon-tw-c.svg'
import iconTwitter from './../images/icon-li-c.svg'
import { addContact } from '../../../api'
import whatsapp from './../images/whatsapp.svg'

function ContactUs(){
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [ formData, setFormData ] = useState({
    name: "",
    contactNo: "",
    email: "",
    message: ""
  })

  const handleChange = (event)=>{
    const { name, value } = event.target
    setFormData(prevFormData => {
        return {
            ...prevFormData,
            [name]: value
        }
    })
  }

  const handleSubmit = async (event)=>{
    event.preventDefault()
    try {
      const response = await addContact(formData);
      console.log(response);
      setFormData({
        name: "",
        contactNo: "",
        email: "",
        message: ""
      })
    }  catch (error) {  
      setErrorMessage(error.message)      
      setIsSubmitting(false)
    }
    
  }

  return(
    <>
      <Navbar />

      <main className="contact--container">
        <a className="whatsapp" href="//api.whatsapp.com/send?phone=+919871013411"><img src={whatsapp} alt="send a message" /></a>

        <div className="contact__page">

          <div className="contact__info-section">
            <h1 className="contact__heading">Get in touch with us</h1>
            <div className="contact__info--container">
              <div  className="contact__info">
                <p>CONTACT NUMBER</p>
                <p>+91 9871013411</p>
              </div>
              <div className=" contact__info">
                <p>MAIL-ID</p>
                <p>info@abnurses.com</p>
              </div>
              <div className=" contact__info">
                <p>ADDRESS</p>
                <p>Delhi, India <br/> London, UK</p>
              </div>
            </div>

            <ul className="contact__social">
              <li className="social__icon">
                <a href="https://www.facebook.com/">
                  <img src={iconFb} alt="facebook"/>
                </a>
              </li>
              <li className="social__icon">
                <a href="https://www.linkedin.com/">
                  <img src={iconLinkedin} alt="linkedin"/>
                </a>
              </li>
              <li className="social__icon">
                <a href="https://twitter.com/home">
                  <img src={iconTwitter} alt="twitter"/>
                </a>
              </li>
            </ul>
          </div>
          <form onSubmit={handleSubmit} className="contact__form">
            <input type="text" className="form__input" name="name" placeholder="Name" onChange={handleChange} value={formData.name} required/>
            <input type="tel" pattern="^\d{10}$" className="form__input" name="contactNo" placeholder="Contact Number" onChange={handleChange} value={formData.contactNo} required/>
            <input type="email" className="form__input" name="email" placeholder="E-mail" onChange={handleChange} value={formData.email} required/>
            <textarea name="message" className="form__textarea" placeholder="Message" onChange={handleChange} value={formData.message} required/>
            <button className="submitbtn">SUBMIT</button>
          </form>
        </div>
      </main>
      <Footer />
    </>
  )
}

export default ContactUs
